export default __webpack_public_path__ + "static/media/CncImg.45ab820d.png";